// generated by genversion
export var version = '4.3.0';
//# sourceMappingURL=version.js.map